import { Component } from '@angular/core';

/**
 * @deprecated - Will be removed with the Angular 23 migration.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
@Component({
    selector: 'ap-grid-col',
    templateUrl: './col.component.html'
})
export class ApColComponent {}
